import React from "react";
import ViewsLoading from "theme/views/ViewsLoading";
import loadable from "@loadable/component";

const options = {
    fallback: <ViewsLoading />,
};

export default {
    article_collection: loadable(() => import("./ArticleCollection"), options),
    default: loadable(() => import("./Default"), options),
};
